module.exports = __webpack_public_path__ + "static/media/globe.d5554a92.svg";